import { useSelector } from 'react-redux';

import { selectPaymentMethod } from '@cashier/cashier-data-access';

interface UsePaymentMethod {
  name: string;
  logo: string;
  description: string | null;
}

export const usePaymentMethod = (): UsePaymentMethod => {
  const paymentMethod = useSelector(selectPaymentMethod);

  const { name, logo, description } = paymentMethod;

  return {
    name,
    logo,
    description: description || null,
  };
};
